<template>
  <div>
    <fixed-header id="sticky-header">
      <div class="row form-header py-2">
        <div class="col-sm-4 col-xl-4 m-auto">
          <router-link 
            class="h6"
            tag="a"
            to="/job"
          >
          <i class="uil-arrow-left"></i> {{$t('job.plural').toUpperCase()}} 
          </router-link>
        </div>
        <div class="col-sm-8 col-md-8 text-sm-right">
          <div class="btn-group d-sm-inline-block">
            <input readonly hidden id="copyURL" ref="copyURL" v-model="job_url">
            <!-- <button v-if="job_url === ''" class="btn2 btn2-primary btn-sm mr-1" @click="urlGenerate" > Generate URL </button>
            <button v-else class="btn2 btn2-primary btn-sm mr-1" @click="copyURL"> Copy URL </button> -->
            <button v-if="job_company_url === ''" class="btn2 btn2-primary btn-sm mr-1" @click="urlCompanyGenerate" > Generate URL </button>
            <button v-else class="btn2 btn2-primary btn-sm mr-1" @click="copyCompanyURL"> Copy URL </button>

            <button class="btn btn-warning btn-sm mr-1"
              v-b-modal.choose-mode
              v-if="model.active && (model.slots - model.hired) > 0 "
            > {{$t('job.action.submit_candidate')}} </button>

            <button 
              class="btn btn-sm mr-1"
              :class="model.active ? 'btn-danger' : 'btn-success'"
              @click="onActivate"
              v-if="user.role.role == 'administration'"
            >{{ !model.active ? $t('job.action.activate') : $t('job.action.deactivate') }}</button>

            <!-- <button 
              class="btn btn-sm mr-1"
              :class="'btn-soft-secondary'"
              @click="onPublish"
              v-if="user.role.role == 'administration' && !model.published"
            ><i class="uil-file-check"></i> {{ !model.published ? 'Publish' : 'Deactivate' }}</button> -->

            <router-link
              tag="button"
              :to="'form?id=' + $route.query.id"
              class="btn btn-info btn-sm"
              v-if="user.role.role == 'administration'"
            >
              <i class="uil uil-edit mr-1"></i>{{$t('common.edit')}}
            </router-link>
          </div>
        </div>
      </div>
    </fixed-header>

    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body">
            <div >
              <span class="mt-1 mb-2 text-right ba  dge  badge-pill float-right"
                :class="model.active ? 'badge-success' : 'badge-danger'"
              >{{ model.active ? $t('job.badges.active') : $t('job.badges.deactivated') }}</span>

              <!-- <span class="mt-1 mb-2 mx-2 text-right ba  dge  badge-pill float-right"
                :class="model.published ? 'badge-success' : 'badge-soft-secondary'"
              >{{ model.published ? 'Published' : 'Draft' }}</span> -->

              <span class="mt-1 mb-2 mx-1 text-right ba  dge  badge-pill float-right badge-danger"
                v-if="!model.remaining"
              >{{$t('job.badges.no_slot')}}</span>
            </div>

            <div class="media border-bottom mb-3">
              <img 
                :src="model.company_id.avatar_path" 
                class="mr-3 avatar-lg rounded" 
                alt="shreyu">
              <div class="media-body">
                  <h5 class="mt-1 mb-0">{{model.title}}</h5>
                  <h6 class="font-weight-normal mt-1 mb-1">
                    {{model.company_id.name}}
                  </h6>
                  <p class="text-muted">{{model.city}}, {{model.country}}</p>

                  <p class="text-muted">
                    <span class="mr-2" v-if="model.company_id.contact_no"><i class="mr-2 uil-phone"></i> {{model.company_id.contact_no}} </span>
                    <span class="mr-2" v-if="model.company_id.email"><i class="mr-2 uil-envelope"></i> {{model.company_id.email}} </span>
                    <span class="mr-2" v-if="model.company_id.website"><i class="mr-2 uil-globe"></i> {{model.company_id.website}} </span>
                  </p>
                  
              </div>
            </div>
            <div  v-if="user.role.role == 'administration' || user.role.role == 'staff'" v-html="model.summary"></div>
            <div v-html="model.description"></div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="media-body p-1">
                  <h6 class="mt-1 mb-0 font-size-15">{{$t('job.form.reference_no.label')}}</h6>
                  <h6 class="text-muted font-weight-normal mt-1 mb-3">{{model.reference_no}}</h6>
                </div>
                <div class="row col-12">
                  <div class="media-body p-1 col-5">
                    <h6 class="mt-1 mb-0 font-size-15">{{$t('job.form.employment_type.label')}}</h6>
                    <h6 class="text-muted font-weight-normal mt-1 mb-3">{{model.employment_type}}</h6>
                  </div>
                  <div class="media-body p-1 col-5">
                    <h6 class="mt-1 mb-0 font-size-15">{{$t('job.form.level.label')}}</h6>
                    <h6 class="text-muted font-weight-normal mt-1 mb-3">{{model.level}}</h6>
                  </div>
                  <div class="media-body p-1 col-2">
                    <h6 class="mt-1 mb-0 font-size-15">{{$t('job.form.slots.label')}}</h6>
                    <h6 class="font-weight-bolder mt-1 mb-3">{{ (model.slots - model.hired) > 0 ? model.slots - model.hired : 0 }} / {{model.slots}}</h6>
                  </div>
                  <div class="media-body p-1 col-2" v-if="user.role.role == 'administration'">
                    <h6 class="mt-1 mb-0 font-size-15">Hired</h6>
                    <h6 class="font-weight-bolder mt-1 mb-3">{{model.hired}}</h6>
                  </div>
                </div>
                
                <div class="media-body p-1" >
                  <h6 class="mt-1 mb-0 font-size-15">{{$t('job.form.industry.label')}}</h6>
                  <div class="mt-1 mb-3">
                    <span class="badge badge-pill badge-soft-primary mr-2 mb-2" 
                      v-for="item in model.industry_id"
                      :key="item._id">
                      {{item.name}}
                    </span>

                    <!-- <span v-if="model.industry_id.length == 0">
                      N/A
                    </span> -->
                  </div>
                </div>
                <div class="media-body p-1">
                  <h6 class="mt-1 mb-0 font-size-15">{{$t('job.form.function.label')}}</h6>
                  <div class="mt-1 mb-3">
                    <span class="badge badge-pill badge-soft-primary mr-2 mb-2" 
                      v-for="item in model.function_id"
                      :key="item._id">
                      {{item.name}}
                    </span>

                    <!-- <span v-if="model.function_id.length == 0">
                      N/A
                    </span> -->
                  </div>
                </div>
                <div class="media-body p-1">
                  <h6 class="mt-1 mb-0 font-size-15">{{model.use_min_max_salary ? $t('job.form.salary_range') : 'Salary'}}</h6>
                  <h6 class="text-muted font-weight-normal mt-1 mb-3" v-if="model.use_min_max_salary">{{model.min_salary ? model.min_salary.$numberDecimal : 0 | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2) }} - {{model.max_salary ? model.max_salary.$numberDecimal : 0 | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2)}}</h6>
                  <h6 class="text-muted font-weight-normal mt-1 mb-3" v-else>{{model.salary}}</h6>
                </div>

                <div class="media-body p-1 row" v-if="user.role.role == 'administration' || user.role.role == 'recruitment' || user.role.role == 'staff'">
                  <div class="media-body p-1 col-6">
                    <h6 class="mt-1 mb-0 font-size-15">{{$t('job.form.fees')}}</h6>
                    <h6 class="text-muted font-weight-normal mt-1 mb-3">{{model.fixed && model.rate ? model.rate.$numberDecimal : '' | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2)}}
                      {{!model.fixed && model.rate ? model.rate.$numberDecimal + '%' : ''}}
                    </h6>
                  </div>
                  <div class="media-body p-1 col-6">
                    <h6 class="mt-1 mb-0 font-size-15">My Fee</h6>
                    <h6 class="text-muted font-weight-normal mt-1 mb-3">{{user.fixed && user.rate ? user.rate.$numberDecimal : '' | currency(currency_symbol, currency_symbol == '¥' ? 0 : 2)}}
                      {{!user.fixed && user.rate ? user.rate.$numberDecimal + '%' : ''}}
                    </h6>
                  </div>
                  
                </div>

              </div> 
            </div> 
          </div>
          <div class="col-md-12">
            <div class="card">
              <div class="card-title border-bottom p-3 mb-0 header-title">{{$t('job.applicants.title')}}</div>

              <div class="card-body bg-light">

                <div class="text-center" v-if="applicantLoading">
                  <div class="spinner-grow text-primary m-2 " role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                
                <div class="text-center my-4"
                  v-if="!applicants.length && !applicantLoading"
                >{{$t('job.applicants.empty')}}</div>

                <VuePerfectScrollbar style="max-height: 300px"
                  v-if="!applicantLoading"
                >
                  <div
                    class="card"
                    v-for="item in applicants"
                    :key="item._id">
                    <div class="btn text-left media p-2 "
                      @click="onSelectApplicant(item)"
                    >
                      <img 
                        :src="item[item.whatId].avatar_path"
                        class="mr-3 avatar-lg rounded" 
                        alt="avatar">
                        <div class="media-body">
                          <h5 class="mt-1 mb-0">{{item[item.whatId].full_name}} <span class="small" v-if="item.reference_no">#{{item.reference_no}}</span></h5>
                          <p class="text-muted m-0">{{item[item.whatId].email}}</p>

                          <applicantProgress 
                            :status="item.status"
                            :applicant="item"
                          />
                        </div>
                    </div>
                  </div>
                </VuePerfectScrollbar>
              </div> 
            </div> 
          </div>

          <div class="col-md-12" >
            <div class="card">
              <div class="card-title border-bottom p-3 mb-0 header-title">{{$t('job.placed_applicants.title')}}</div>

              <div class="card-body bg-light">

                <div class="text-center" v-if="placeApplicantLoading">
                  <div class="spinner-grow text-primary m-2 " role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                
                <div class="text-center my-4"
                  v-if="!placed_applicants.length && !placeApplicantLoading"
                >{{$t('job.placed_applicants.empty')}}</div>

                <VuePerfectScrollbar style="max-height: 300px"
                  v-if="!placeApplicantLoading"
                >
                  <div
                    class="card"
                    v-for="item in placed_applicants"
                    :key="item._id">
                    <div class="btn text-left media p-2">
                      <img 
                        :src="item[item.whatId].avatar_path"
                        class="mr-3 avatar-lg rounded" 
                        alt="avatar">
                        <div class="media-body">
                          <h5 class="mt-1 mb-0">{{item[item.whatId].full_name}} <span class="small" v-if="item.reference_no">#{{item.reference_no}}</span></h5>
                          <p class="text-muted m-0">{{item[item.whatId].email}}</p>

                          <applicantProgress 
                            :status="item.status"
                          />
                        </div>
                    </div>
                  </div>
                </VuePerfectScrollbar>
              </div> 
            </div> 
          </div>

          <div class="col-md-12" >
            <div class="card">
              <div class="card-title border-bottom p-3 mb-0 header-title">{{$t('job.rejected_applicants.title')}}</div>

              <div class="card-body bg-light">

                <div class="text-center" v-if="placeApplicantLoading">
                  <div class="spinner-grow text-primary m-2 " role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                
                <div class="text-center my-4"
                  v-if="!rejected_applicants.length && !rejectedApplicantLoading"
                >{{$t('job.rejected_applicants.empty')}}</div>

                <VuePerfectScrollbar style="max-height: 300px"
                  v-if="!rejectedApplicantLoading"
                >
                  <div
                    class="card"
                    v-for="item in rejected_applicants"
                    :key="item._id">
                    <div class="btn text-left media p-2">
                      <img 
                        :src="item[item.whatId].avatar_path"
                        class="mr-3 avatar-lg rounded" 
                        alt="avatar">
                        <div class="media-body">
                          <h5 class="mt-1 mb-0">{{item[item.whatId].full_name}} <span class="small" v-if="item.reference_no">#{{item.reference_no}}</span></h5>
                          <p class="text-muted m-0">{{item[item.whatId].email}}</p>

                          <applicantProgress 
                            :status="item.status"
                          />
                        </div>
                    </div>
                  </div>
                </VuePerfectScrollbar>
              </div> 
            </div> 
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="choose-mode"
      size="md"
      :title="$t('job.submit_window.window_title')"
      title-class="font-18"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      body-class="bg-light"
      >
      <div class="row">

        <div class="col-md-6">
          <a href="#" 
            @click="modeUpload(true)"
            class="card">
            <div class="media p-3">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="edit" class="icon-xxl"></feather>
                </div>
                <h4 class="mb-0">{{$t('job.submit_window.action.manual_input')}}</h4>
              </div>
            </div>
          </a>
        </div>

        <!-- <div class="col-md-4">
          <a href="#" 
            @click="modeUpload(false)"
            class="card">
            <div class="media p-3">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="upload" class="icon-xxl"></feather>
                </div>
                <h4 class="mb-0">{{$t('job.submit_window.action.upload_resume')}}</h4>
              </div>
            </div>
          </a>
        </div> -->

        <div class="col-md-6">
          <a href="#" 
            @click="modeSelect"
            class="card">
            <div class="media p-3">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="users" class="icon-xxl"></feather>
                </div>
                <h4 class="mb-0">{{$t('job.submit_window.action.select_candidate')}}</h4>
              </div>
            </div>
          </a>
        </div>
      </div>
      
      
    </b-modal>

    <b-modal
      id="select-candidate-modal"
      size="lg"
      title="Select a candidate"
      title-class="font-18"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      body-class="bg-light"
      >
      <div class="text-muted text-center" v-if="!candidates.length">
        No Candidate(s) available as of the moment, please submit candidate instead.
      </div>

      <VuePerfectScrollbar style="max-height: 400px">
        <div class="text-center loaderko" v-if="loadSelectCandidate">
          <div class="spinner-grow text-primary m-2 " role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div class="text-muted small">Loading</div>
        </div>
        <div class="row">
          <div class="col-md-6"
            v-for="item in candidates"
            :key="item._id"
          >
            <a href="#" 
              @click="onSelectCandidate(item._id)"
              class="card">
              <div class="media p-2">
                <img 
                  :src="item.avatar_path"
                  class="mr-3 avatar-lg rounded" 
                  alt="avatar">
                <div class="media-body">
                  <h5 class="mt-1 mb-0">{{item.full_name}}</h5>
                  <h6 class="font-weight-normal mt-1 mb-1">{{item.work_experiences[0] ? item.work_experiences[0].position : 'No Employment'}}</h6>
                  <p class="text-muted m-0">{{item.email}}</p>
                </div>
              </div>
            </a>
          </div>

        </div>
      
      </VuePerfectScrollbar>
    </b-modal>

    <!-- <b-modal
      id="update-applicant-modal"
      size="md"
      :title="$t('job.applicant_window.action.update_status.window_title')"
      title-class="font-18"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      body-class="bg-light"
      >
      <div>
        <div class="media p-2">
          <img 
            :src="new_applicant[new_applicant.whatId].avatar_path"
            class="mr-3 avatar-lg rounded" 
            alt="avatar"
          >
          <div class="media-body">
            <h5 class="mt-1 mb-0">{{new_applicant[new_applicant.whatId].full_name}}</h5>
            <p class="text-muted m-0">{{new_applicant[new_applicant.whatId].email}}</p>

            <applicantProgress 
              :status="new_applicant.status"
            />
          </div>
        </div>

        <DropDown 
          :label="$t('job.applicant_window.action.update_status.status.label')"
          :options="status_option"
          :name.sync="new_applicant.status"
          v-model="new_applicant.status"
        />
        <div class="row">
          <div class="col-md-12">
            <button class="btn2 btn2-primary btn2-md btn-block"
            @click="onUpdateApplicant"
            ><i class="uil uil-message"></i> {{$t('job.applicant_window.action.update_status.ok_button')}}</button>
          </div>
        </div>
      </div>
    </b-modal> -->

    <b-modal
      id="update-salary-modal"
      size="md"
      title="Update Candidate Window"
      title-class="font-18"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      body-class="bg-light"
      >
      <div>
        <div class="media p-2">
          <img 
            :src="new_applicant[new_applicant.whatId].avatar_path"
            class="mr-3 avatar-lg rounded" 
            alt="avatar"
          >
          <div class="media-body">
            <h5 class="mt-1 mb-0">{{new_applicant[new_applicant.whatId].full_name}}</h5>
            <p class="text-muted m-0">{{new_applicant[new_applicant.whatId].email}}</p>

            <applicantProgress 
              :status="new_applicant.status"
            />
          </div>
        </div>

        <DropDown 
          label="Change Status"
          :options="status_option"
          :name.sync="new_applicant.status"
          v-model="new_applicant.status"
        />
        <div class="row">
          <!-- <div class="col-md-6">
            <button class="btn btn-soft-danger btn-block"
            @click="onRemoveApplicant"
            ><i class="uil uil-trash"></i> Remove Applicant</button>
          </div> -->
          <div class="col-md-12">
            <button class="btn2 btn2-primary btn2-md btn-block"
            @click="onUpdateApplicant"
            ><i class="uil uil-message"></i> Update Applicant</button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="applicant-modal"
      size="lg"
      :title="$t('job.applicant_window.title')"
      title-class="font-18"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      body-class="bg-light"
      @close="loadCandidate"
      >

      <div class="row">

        <div class="col-md-4" v-if="applicant.confirmed_schedule && user.role.role == 'administration'">
          <a href="#" 
            @click="anotherInterview"
            class="card">
            <div class="media p-3" style="height:185px">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="calendar" class="icon-xxl icon-dual-primary"></feather>
                </div>
                <h2 class="mb-0">Initiate Another Interview</h2>
              </div>
            </div>
          </a>
        </div>

        <!-- <div class="col-md-4" v-if="!applicant.rejected && applicant.approved">
          <a href="#" 
            @click="updateApplication"
            class="card">
            <div class="media p-3" style="height:185px">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="edit-3" class="icon-xxl icon-dual-primary"></feather>
                </div>
                <h2 class="mb-0">{{$t('job.applicant_window.action.update_status.title')}}</h2>
              </div>
            </div>
          </a>
        </div> -->

        <div class="col-md-4" v-if="!applicant.rejected && applicant.confirmed_schedule && applicant.approved">
          <a href="#" 
            @click="offerSalary"
            class="card">
            <div class="media p-3" style="height:185px">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="trending-up" class="icon-xxl icon-dual-success"></feather>
                </div>
                <h2 class="mb-0">{{$t('job.applicant_window.action.offer_salary.title')}}</h2>
              </div>
            </div>
          </a>
        </div>

        <div class="col-md-4" v-if="applicant.offer_accepted  && applicant.approved">
          <a href="#" 
            @click="onPlaceCandidate"
            class="card">
            <div class="media p-3" style="height:185px">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="user-plus" class="icon-xxl icon-dual-success"></feather>
                </div>
                <h2 class="mb-0">{{$t('job.applicant_window.action.place_candidate.title')}}</h2>
              </div>
            </div>
          </a>
        </div>

        <!-- <div class="col-md-4">
          <a href="#" 
            @click="modeSelect"
            class="card">
            <div class="media p-3" style="height:185px">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="calendar" class="icon-xxl icon-dual-primary"></feather>
                </div>
                <h2 class="mb-0">Override Schedule</h2>
              </div>
            </div>
          </a>
        </div> -->

        <div class="col-md-4" v-if="applicant.approved">
          <a href="#" 
            @click="addFeedback"
            class="card">
            <div class="media p-3" style="height:185px">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="edit" class="icon-xxl icon-dual-warning"></feather>
                </div>
                <h2 class="mb-0">{{$t('job.applicant_window.action.add_feedback.title')}}</h2>
              </div>
            </div>
          </a>
        </div>

        <div class="col-md-4" v-if=" applicant.approved">
          <a href="#" 
            @click="onRejectApplicant"
            class="card">
            <div class="media p-3" style="height:185px">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="x-circle" class="icon-xxl icon-dual-danger"></feather>
                </div>
                <h2 class="mb-0">{{$t('job.applicant_window.action.reject_candidate.title')}}</h2>
              </div>
            </div>
          </a>
        </div>

        <div class="col-md-4">
          <a href="#" 
            @click="onRemoveApplicant"
            class="card">
            <div class="media p-3" style="height:185px">
              <div class="media-body text-center">
                <div class="align-self-center">
                  <feather type="trash" class="icon-xxl icon-dual-danger"></feather>
                </div>
                <h2 class="mb-0">{{$t('job.applicant_window.action.remove_candidate.title')}}</h2>
              </div>
            </div>
          </a>
        </div>


      </div>
      
    </b-modal>

    <b-modal
      id="upload-candidate-modal"
      size="lg"
      :title="manual ? $t('common.manual_input.window_title') : $t('common.upload_resume.window_title')"
      title-class="font-18"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      body-class="bg-light"
      static
      >
      <form-wizard ref="uploadwizard" 
        color="#5369f8" 
        error-color="#ff5c75"
        :next-button-text="$t('common.upload_resume.next_button')"
        :back-button-text="$t('common.upload_resume.back_button')"
        :finish-button-text="$t('common.upload_resume.finish_button')"
        @on-complete="onComplete">

        <tab-content
          :title="$t('common.upload_resume.steps.step1.title')"
          :before-change="() => validateStep('step0')"
        >
          <Step0 ref="step0" @on-validate="mergePartialModels"/>
        </tab-content>

        <tab-content
          :title="$t('common.upload_resume.steps.step2.title')"
          :before-change="() => validateStep('step1')"
        >
          <Step1 ref="step1" :data="finalModel.user" @on-validate="mergePartialModels" @close-error-modal="closeAllModals"/>
        </tab-content>

        <tab-content
          :title="$t('common.upload_resume.steps.step3.title')"
          :before-change="() => validateStep('step2')"
        >
          <Step2 ref="step2" :data="finalModel.work_experiences" @on-validate="mergePartialModels" />
        </tab-content>
        <tab-content
          :title="$t('common.upload_resume.steps.step4.title')"
          :before-change="() => validateStep('step3')"
        >
          <Step3 ref="step3" :data="finalModel.educations"  @on-validate="mergePartialModels" />
        </tab-content>
        <tab-content
          :title="$t('common.upload_resume.steps.step5.title')"
          :before-change="() => validateStep('step4')"
        >
          <Step4 ref="step4" :data="finalModel.skills" @on-validate="mergePartialModels" />
        </tab-content>
        <tab-content 
          :title="$t('common.upload_resume.steps.step6.title')"
          :before-change="() => validateStep('step5')"
        >
          <Step5 ref="step5" :data="finalModel" @on-validate="mergePartialModels" />
        </tab-content>
      </form-wizard>
    </b-modal>

    <b-modal
      id="manual-candidate-modal"
      size="lg"
      :title="manual ? $t('common.manual_input.window_title') : $t('common.upload_resume.window_title')"
      title-class="font-18"
      no-close-on-esc
      no-close-on-backdrop
      centered
      hide-footer
      body-class="bg-light"
      static
      >
      <form-wizard ref="manualwizard" 
        color="#5369f8" 
        error-color="#ff5c75"
        :next-button-text="$t('common.upload_resume.next_button')"
        :back-button-text="$t('common.upload_resume.back_button')"
        :finish-button-text="$t('common.upload_resume.finish_button')"
        @on-complete="onComplete">

        <tab-content
          :title="$t('common.upload_resume.steps.step2.title')"
          :before-change="() => validateStep('manual_step1')"
        >
          <Step1 ref="manual_step1" :data="finalModel.user" @on-validate="mergePartialModels" />
        </tab-content>

        <!-- <tab-content
          :title="$t('common.upload_resume.steps.step3_5.title')"
          :before-change="() => validateStep('manual_step2')"
        >
          <Step05 ref="manual_step1" :userData="finalModel.user" @on-validate="mergePartialModels" />
        </tab-content> -->
        <tab-content 
          :title="$t('common.upload_resume.steps.step6.title')"
          :before-change="() => validateStep('manual_step5')"
        >
          <Step55 ref="manual_step5" :data="finalModel" @on-validate="mergePartialModels" />
        </tab-content>
      </form-wizard>
    </b-modal>

    <b-modal title="Warning" id="bv-modal-error" hide-footer>
      <div class="d-block text-center">
        <h5>Candidate already exists on our system. We have forwarded the info to admin and Jinz.ai admin will contact you directly</h5>
      </div>
      <b-button class="mt-3 btn2 btn2-primary btn-sm mr-1" block @click="closerErrorModal()">Ok</b-button>
    </b-modal>

    <FeedbackModal :feedbacks="feedbacks" :application="applicant"/>
    <RejectModal :application="applicant"/>
    <OfferSalaryModal :application="applicant"/>
    <!-- <PlaceCandidateModal :application="applicant"/> -->
  </div>
</template>

<script>
import FixedHeader from 'vue-fixed-header'
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import applicantProgress from '@components/applicantProgress'
import DropDown from '@components/form/dropdown.vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import Step0 from '@pages/job/step0'
import Step1 from '@pages/job/step1'
import Step2 from '@pages/job/step2'
import Step3 from '@pages/job/step3'
import Step4 from '@pages/job/step4'
import Step5 from '@pages/job/step5'
import Step55 from '@pages/job/step5_5'
// import Step05 from '@pages/job/step0_5'
import FeedbackModal from '@components/modals/feedbackModal'
import RejectModal from '@components/modals/rejectModal'
import OfferSalaryModal from '@components/modals/offerSalaryModal'
/* import PlaceCandidateModal from '@components/modals/placeCandidateModal' */

export default {
  mixins: [FormMixin],
  data(){
    return {
      job_url: '',
      job_company_url: '',
      manual: true,
      finalModel:{
        user:{},
        work_experiences:[],
        educations:[],
        skills:[]
      },
      model:{
        active:true,
        company_id:{
          name:''
        },
        currency_id:{
          symbol:''
        },
        url: ''
      },

      feedbacks:[],
      application:[],
      candidate:[],

      candidates:[],
      applicants:[],
      placed_applicants:[],
      rejected_applicants:[],
      applicant:{},
      new_applicant:{
        whatId:'candidate_id',
        candidate_id:{
          avatar_path:''
        },
        prospect:{
          avatar_path:''
        }
      },
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth,
      applicantLoading:false,
      placeApplicantLoading:false,
      rejectedApplicantLoading:false,
      loadSelectCandidate:false,
      status_option:[
        /* { value: null, text: 'Pending' }, */
        { value: 'Sent', text: 'Sent' },
        { value: 'First Interview', text: 'First Interview' },
        { value: 'Second Interview', text: 'Second Interview' }/*,
        { value: 'Offered', text: 'Offered' } ,
        { value: 'Placed', text: 'Placed' }, */
      ],
    }
  },

  components:{FixedHeader, VuePerfectScrollbar, applicantProgress, DropDown, FormWizard, TabContent,
    Step0, Step1, Step2, Step3, Step4, Step5, Step55,
    FeedbackModal, RejectModal, OfferSalaryModal/* , PlaceCandidateModal */
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('job', ['find', 'activate', 'applyJob', 'getApplicants', 'updateApplicant', 'publishJob', 'removeApplicant', 'generateUrl', 'getUrl', 'getCompanyUrl']),
    ...mapActions('prospect', ['findUserProspect', 'findProspect']),
    ...mapActions('candidate', ['getFeedback','placeCandidate', 'findUserCandidate']),
    anotherInterview(){
      this.$bvModal.msgBoxConfirm('Are you sure you want to initiate another interview for this applicant? This will send an email to the employer with new link for candidates.', {
        title: 'Please Confirm Action',
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()
          this.$store.dispatch('candidate/setAnotherInterview', {id:this.applicant._id}).then(res => {
            this.applicant = res.data
            this.$bvToast.toast(`Another interview was initiated for applicant ${res.data.full_name}!`, {
              title: 'Notification',
              variant:'success'
            })
            this.toggleLoading()
          })
        }
      })
    },
    handleResize () {
      let header = document.getElementById('sticky-header');
      this.fullWidth = document.getElementsByClassName('content-page').item(0).clientWidth

      if(header){
        header.style.width = this.fullWidth + 'px'
      }
    },
    validateStep(name) {
			var refToValidate = this.$refs[name]
			return refToValidate.validate()
		},
		mergePartialModels(model, isValid, showError = false) {
      if(!showError){
        if (isValid && model) {
          // merging each step model into the final model
          this.finalModel = Object.assign({}, this.finalModel, model)
        }
        this.finalModel.job_id = this.model._id
      }else{
        this.closeAllModals()
      }
    },
    resetWizard(){
      let wiz = this.manual ? ['manual_step2'] : ['step0']
      
      for(var key in wiz){
        var refToValidate = this.$refs[wiz[key]]
        refToValidate.reset()
      }

    },
    closerErrorModal(){
      this.$bvModal.hide('bv-modal-error')
    },
    closeAllModals(){
      this.$bvModal.show('bv-modal-error')
      this.$bvModal.hide('upload-candidate-modal')
      this.$bvModal.hide('manual-candidate-modal')
      this.$bvModal.hide('choose-mode')

      this.$refs['manual_step1'].reset()

      this.resetWizard()
    },
    onComplete(){
      this.$bvModal.hide('upload-candidate-modal')
      this.$bvModal.hide('manual-candidate-modal')
      this.$bvModal.hide('choose-mode')

      this.$bvToast.toast(`Application was submitted!`, {
        title: 'Notification',
        variant:'success'
      })

      this.finalModel = {
        user:{},
        work_experiences:[],
        educations:[],
        skills:[]
      }

      this.$refs['uploadwizard'].reset()
      this.$refs['manualwizard'].reset()

      this.resetWizard()

      this.loadCandidate()
    },
    onActivate () {
      
      this.$bvModal.msgBoxConfirm('Are you sure you want to ' + (this.model.active ? 'Deactivate' : 'Activate'), {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()

          this.activate(this.model).then(res => {
            this.model.active = res.data.active
            this.$bvToast.toast(`Job #${res.data.reference_no} has been ${res.data.active ? 'Activated' : 'Deactivated'}!`, {
              title: 'Notification',
              variant:'success'
            })
            this.toggleLoading()
          })
        }
      })
    },
    onPublish(){
      this.$bvModal.msgBoxConfirm('Please confirm that you want to publish this job', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()
          this.publishJob({
            id:this.$route.query.id,
          }).then(res => {
            if(res.data.published){
              this.model.published = res.data.published
              this.$bvToast.toast(`Job #${res.data.reference_no} has been published!`, {
                title: 'Notification',
                variant:'success'
              })
              this.find({
                id:this.$route.query.id
              }).then(data => {
                this.model = data.data
              })
              this.loadCandidate()
              this.toggleLoading()
            }
          })
        }
      })
    },
    async urlGenerate(){
      let me = this
      await this.generateUrl({
        id:this.model._id
      }).then(res => {
        me.job_url = res.data
      })
    },
    async urlCompanyGenerate(){
      let me = this
      await this.generateUrl({
        id:this.model._id,
        company:true
      }).then(res => {
        me.job_company_url = res.data
      })
    },
    copyURL(){
      this.$copyText(this.job_url).then(function () {
        alert('Job URL copied successfully')
      }, function () {
        alert('Failed to copy URL: Please contact Administrator')
      })
      // let codeToCopy = document.querySelector('#copyURL')
      // codeToCopy.removeAttribute('hidden', 'hidden')
      // codeToCopy.select()

      // try {
      //   document.execCommand('copy');
      //   alert('Job URL copied successfully');
      // } catch (err) {
      //   alert('Oops, unable to copy');
      // }
      // codeToCopy.setAttribute('hidden', 'hidden')
      // window.getSelection().removeAllRanges()
    },
    copyCompanyURL(){
      this.$copyText(this.job_company_url).then(function () {
        alert('Job URL copied successfully')
      }, function () {
        alert('Failed to copy URL: Please contact Administrator')
      })
      // let codeToCopy = document.querySelector('#copyURL')
      // codeToCopy.removeAttribute('hidden', 'hidden')
      // codeToCopy.select()

      // try {
      //   document.execCommand('copy');
      //   alert('Job URL copied successfully');
      // } catch (err) {
      //   alert('Oops, unable to copy');
      // }
      // codeToCopy.setAttribute('hidden', 'hidden')
      // window.getSelection().removeAllRanges()
    },
    onSelectCandidate(uiid){
      this.loadSelectCandidate = true

      this.applyJob({
        id:this.model._id,
        candidate_id:uiid
      }).then(res => {
          this.loadSelectCandidate = false
        //if(res.data._id){
          this.$bvModal.hide('select-candidate-modal')

          if(res.data.success){
            this.loadCandidate()
          }else{
            this.load()
          }

          this.$bvToast.toast(res.data.toastMessage, {
            title: 'Notification',
            variant:res.data.success ? 'success' : 'danger'
          })
          
        //}

      })
    },
    loadCandidate(){
      /* if(!this.model.published){
        return
      } */
      this.applicantLoading = true 
      this.placeApplicantLoading = true 

      this.applicant = {}
      this.getApplicants({
        id:this.$route.query.id
      }).then(res => {
        this.applicantLoading = false
        this.applicants = res.data || []
      })

      this.getApplicants({
        id:this.$route.query.id,
        placed:true
      }).then(res => {
        this.placeApplicantLoading = false 
        this.placed_applicants = res.data || []
      })

      this.getApplicants({
        id:this.$route.query.id,
        rejected:true
      }).then(res => {
        this.rejectedApplicantLoading = false 
        this.rejected_applicants = res.data || []
      })
      this.applicant
    },
    onSelectApplicant(item){
      this.applicant = item
      this.new_applicant = {...item}
      this.$bvModal.show('applicant-modal')
      return
    },
    updateApplication(){
      this.$bvModal.show('update-applicant-modal')
    },
    offerSalary(){
      this.$bvModal.show('offer-salary-modal')
    },
    onPlaceCandidate(){
      this.$bvModal.msgBoxConfirm(this.$t('job.applicant_window.action.place_candidate.window_body'), {
        title: this.$t('job.applicant_window.action.place_candidate.window_title'),
        size: 'md',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: this.$t('job.applicant_window.action.place_candidate.ok_button'),
        cancelTitle: this.$t('job.applicant_window.action.place_candidate.cancel_button'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()

          this.placeCandidate({
            id:this.applicant._id
          }).then(() => {
            this.loadCandidate()
            this.$bvToast.toast(`Applicant was successfully place!`, {
              title: 'Notification',
              variant:'success'
            })
            this.$bvModal.hide('applicant-modal')

            this.toggleLoading()

            this.find({
              id:this.$route.query.id
            }).then(data => {
              this.model = data.data
            })
          })
        }
      })
    },
    onRejectApplicant(){
      this.$bvModal.show('reject-modal')
    },
    async addFeedback(){
      await this.getFeedback({
        application_id:this.applicant._id,
        candidate_id:this.applicant.candidate_id._id
      }).then(res => {
        this.feedbacks = res.data
        /* this.application = item._id
        this.candidate = item.candidate_id._id */
      })
      this.$bvModal.show('feedbackModal')
    },
    onRemoveApplicant(){
      this.$bvModal.msgBoxConfirm(this.$t('job.applicant_window.action.remove_candidate.window_body'), {
        title: this.$t('job.applicant_window.action.remove_candidate.window_title'),
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: this.$t('job.applicant_window.action.remove_candidate.ok_button'),
        cancelTitle: this.$t('job.applicant_window.action.remove_candidate.cancel_button'),
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
          this.toggleLoading()

          this.removeApplicant({
            id:this.new_applicant._id
          }).then(() => {
            this.loadCandidate()
            this.$bvToast.toast(`Applicant was successfully removed!`, {
              title: 'Notification',
              variant:'success'
            })
            this.$bvModal.hide('applicant-modal')

            this.toggleLoading()
          })
        }
      })
    },
    onUpdateApplicant(){
      this.toggleLoading()

      this.updateApplicant({
        id: this.new_applicant._id,
        status: this.new_applicant.status
      }).then(res => {
        this.applicant.status = res.data.status
        this.$bvModal.hide('update-applicant-modal')
        this.$bvToast.toast(`Applicant was successfully updated!`, {
          title: 'Notification',
          variant:'success'
        })
        this.toggleLoading()
      }) 
    },
    modeUpload(is_manual = false){
      this.manual = is_manual
      if(is_manual){
        this.$bvModal.show('manual-candidate-modal')
      }else{
        this.$bvModal.show('upload-candidate-modal')
      }
      /* this.$bvModal.msgBoxOk('Sorry Daxtra API is not available for now, please use select candidate.',{
        title: 'Notification'
      }) */
    },
    async modeSelect(){
      this.toggleLoading()

      this.findUserCandidate({
        job_id: this.model._id
      }).then(res => {
        this.candidates = res.data
        this.$bvModal.show('select-candidate-modal')

        this.toggleLoading()
      })
    },
    loadURL(){
      this.getUrl({
        id:this.$route.query.id
      }).then(data => {
        this.job_url = data.data
      })
      this.getCompanyUrl({
        id:this.$route.query.id
      }).then(data => {
        this.job_company_url = data.data
      })
    },
    load(){
      this.find({
        id:this.$route.query.id
      }).then(data => {
        this.model = data.data

        this.loadCandidate()

        this.loadURL()

        /* this.applicantLoading = true 
        if(this.model.published){
          this.getApplicants({
            id:this.model._id
          }).then(res => {
            this.applicantLoading = false 
            this.applicants = res.data
          })
        } */

      })
    }
  },
  beforeMount() {
    this.load()
  },
  mounted(){
    window.addEventListener('resize', this.handleResize)
  },
  updated(){
    this.handleResize()
  },
  computed:{
    currency_symbol(){
      var symbol = ""
      if(this.model.currency_id){
        symbol = this.model.currency_id.symbol
      }
      return symbol
    }
  }
}
</script>

